import { useCallback, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import CustomPropertiesForm from 'automation-ui-management/components/CustomPropertiesForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CustomPropertiesStep({
  flow,
  setFlow,
  workflowProperties,
  customProperties,
  setCustomProperties,
  setValidationMessage
}) {
  useEffect(() => {
    if (workflowProperties.some(property => property.propertyName === 'hs_name')) {
      setCustomProperties({
        hs_name: flow.name
      });
    }
  }, [flow.name, setCustomProperties, workflowProperties]);
  const handlePropertyChange = useCallback(updatedCustomProperties => {
    setCustomProperties(updatedCustomProperties);
    if ('hs_name' in updatedCustomProperties) {
      setFlow(draftFlow => {
        var _updatedCustomPropert;
        draftFlow.name = (_updatedCustomPropert = updatedCustomProperties.hs_name) !== null && _updatedCustomPropert !== void 0 ? _updatedCustomPropert : undefined;
      });
    }
  }, [setCustomProperties, setFlow]);
  const handleStatusChange = useCallback(status => {
    var _status$saveable, _status$errors, _status$errors2;
    const saveable = (_status$saveable = status === null || status === void 0 ? void 0 : status.saveable) !== null && _status$saveable !== void 0 ? _status$saveable : false;
    if ((_status$errors = status.errors) !== null && _status$errors !== void 0 && _status$errors.get('INVALID_PROPERTIES')) {
      setValidationMessage(I18n.text('createWorkflow.customProperties.invalidPropertiesTooltip'));
    } else if ((_status$errors2 = status.errors) !== null && _status$errors2 !== void 0 && _status$errors2.get('MISSING_REQUIRED_PROPERTY') || !saveable) {
      setValidationMessage(I18n.text('createWorkflow.customProperties.missingRequiredPropertiesTooltip'));
    } else {
      setValidationMessage(null);
    }
  }, [setValidationMessage]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.customProperties.header"
      })
    }), /*#__PURE__*/_jsx(CustomPropertiesForm, {
      objectId: undefined // we are creating a new record, it has no record id yet
      ,
      onChange: handlePropertyChange,
      onStatusChange: handleStatusChange,
      properties: workflowProperties,
      values: customProperties
    })]
  });
}
export const customPropertiesStep = {
  component: CustomPropertiesStep,
  getLabel: () => I18n.text('createWorkflow.step.customProperties')
};